import {
  Box,
  Button,
  Flex,
  Select,
  InputGroup,
  InputLeftElement,
  Input,
  Heading,
  Text,
  TableContainer,
  Table,
  Thead,
  Tbody,
  Th,
  Tr,
  Td,
  GridItem,
  Textarea,
} from "@chakra-ui/react";
import { TopDisplay } from "../../../../components";
import { LuSearch as SearchIcon } from "react-icons/lu";
import { useState, useEffect, useMemo } from "react";
import styled from "@emotion/styled";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { FiMove as ApprovalIcon } from "react-icons/fi";
import { MdMoreVert as MoreIcon } from "react-icons/md";
import apiCall from "../../../../utils/apiCall";
import {
  Grid,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  PopoverArrow,
} from "@chakra-ui/react";
import { useAtom, atom } from "jotai";
import {
  modalAtom,
  openAtom,
  notificationAtom,
  openNAtom,
} from "../,,/../../../../context";
import { Loader } from "../../../../customs";
import { TbReload as ReloadIcon } from "react-icons/tb";
import ReactPaginate from "react-paginate";
import BatchMigration from "./Modal/BatchMigration";

const indexAtom = atom<number | null>(null);
const list = [
  {
    StudentId: Math.floor(Math.random() * 10000) + 1,
    FirstName: "Abey",
    LastName: "Adesola",
    OldEmail: "Abey.Adesola@gmail.com",
    NewEmail: "Osakpolo@gmail.com",
    Reason: "Not working",
    DateRequested: "01-03-2024",
    Status: "Pending",
  },
  {
    StudentId: Math.floor(Math.random() * 10000) + 1,
    FirstName: "Abey",
    LastName: "Adesola",
    OldEmail: "Abey.Adesola@gmail.com",
    NewEmail: "Osakpolo@gmail.com",
    Reason: "Not working",
    DateRequested: "01-03-2024",
    Status: "Pending",
  },
  {
    StudentId: Math.floor(Math.random() * 10000) + 1,
    FirstName: "Abey",
    LastName: "Adesola",
    OldEmail: "Abey.Adesola@gmail.com",
    NewEmail: "Osakpolo@gmail.com",
    Reason: "Not working",
    DateRequested: "01-03-2024",
    Status: "Pending",
  },
  {
    StudentId: Math.floor(Math.random() * 10000) + 1,
    FirstName: "Abey",
    LastName: "Adesola",
    OldEmail: "Abey.Adesola@gmail.com",
    NewEmail: "Osakpolo@gmail.com",
    Reason: "Not working",
    DateRequested: "01-03-2024",
    Status: "Pending",
  },
  {
    StudentId: Math.floor(Math.random() * 10000) + 1,
    FirstName: "Abey",
    LastName: "Adesola",
    OldEmail: "Abey.Adesola@gmail.com",
    NewEmail: "Osakpolo@gmail.com",
    Reason: "Not working",
    DateRequested: "01-03-2024",
    Status: "Pending",
  },
];

const HeadStyle = {
  borderBottom: "1px solid var(--dark-green-color)",
  padding: "15px 5px",
};
const DataStyle = {
  padding: "5px 5px",
  thcolor: "var(--dark-green-color)",
};

const ROWSTYLE = styled.tr`
  & > td:last-of-type {
    width: 50px;
    height: 63px;
    & > div {
      display: none;
    }
  }
  &:hover > * {
    cursor: pointer;
    background-color: var(--table-highlight);
  }
  & > td {
    width: 140px;
  }
  &:hover > td:last-of-type {
    & > div {
      display: block;
    }
  }
  & > td > div.active {
    display: block;
  }
`;

export default function StudentMigration() {
  const [hide, set_hide] = useState<boolean>(true);
  const [activeIndex] = useAtom(indexAtom);
  const [, set_open] = useAtom(openAtom);
  const [, set_modal] = useAtom(modalAtom);
  const [selected_status, set_selected_status] = useState<null | string>(null);
  const queryClient = useQueryClient();
  const [search, set_search] = useState("");
  const [debounced_search, set_debounced_search] = useState("");
  const itemsPerPage = 100;
  const [pageNumber, set_pageNumber] = useState(1);

  // Debounce the search box so typing doesn't fire a request per keystroke.
  useEffect(() => {
    const timer = setTimeout(() => set_debounced_search(search.trim()), 300);
    return () => clearTimeout(timer);
  }, [search]);

  useEffect(() => {
    set_pageNumber(1);
  }, [debounced_search, selected_status]);

  // This endpoint has no server-side search/status param, so matching needs
  // to span every record - only pull every page (batched) while a search or
  // status filter is actually active, instead of on every normal page load.
  const isFiltering = !!debounced_search || !!selected_status;

  const { data: pagedResult, isLoading: isLoadingPage } = useQuery(
    ["applied-induction-page", pageNumber],
    async () => {
      const res = await apiCall().get(
        `/Exam/students/appliedForInduction/notMovedToMembership?PageNumber=${pageNumber}&PageSize=${itemsPerPage}`
      );
      return res.data;
    },
    {
      enabled: !isFiltering,
      keepPreviousData: true,
      select: (data: any) => ({
        items: data?.reportItems || [],
        totalCount: data?.TotalCount ?? (data?.reportItems || []).length,
        pageCount: data?.PageCount ?? 1,
      }),
    }
  );

  const { data: allMatchingData, isLoading: isLoadingAll } = useQuery(
    ["applied-induction-all"],
    async () => {
      const fetchPageSize = 1000;
      const first = await apiCall().get(
        `/Exam/students/appliedForInduction/notMovedToMembership?PageNumber=1&PageSize=${fetchPageSize}`
      );
      let items = first.data?.reportItems || [];
      const totalPages = first.data?.PageCount || 1;

      if (totalPages > 1) {
        const remainingPages = [];
        for (let page = 2; page <= totalPages; page++) remainingPages.push(page);

        const batchSize = 5;
        for (let i = 0; i < remainingPages.length; i += batchSize) {
          const batch = remainingPages.slice(i, i + batchSize);
          const responses = await Promise.all(
            batch.map((page) =>
              apiCall().get(
                `/Exam/students/appliedForInduction/notMovedToMembership?PageNumber=${page}&PageSize=${fetchPageSize}`
              )
            )
          );
          responses.forEach((res) => {
            items = [...items, ...(res.data?.reportItems || [])];
          });
        }
      }

      return items;
    },
    {
      enabled: isFiltering,
      staleTime: 5 * 60 * 1000,
    }
  );

  const filteredData = useMemo(() => {
    if (!isFiltering) return [];
    let data = allMatchingData || [];
    if (selected_status) {
      data = data.filter((eData: any) => eData.Status?.toLowerCase() === selected_status.toLowerCase());
    }
    if (debounced_search) {
      const term = debounced_search.toLowerCase();
      data = data.filter((eData: any) => Object.values(eData).join(" ").toLowerCase().includes(term));
    }
    return data;
  }, [allMatchingData, selected_status, debounced_search, isFiltering]);

  const showBatchAproval = () => {
    set_modal({
      header: "Batch Migration",
      content: <BatchMigration />,
    });
    set_open(true);
  };

  const currentItems = isFiltering
    ? filteredData.slice((pageNumber - 1) * itemsPerPage, pageNumber * itemsPerPage)
    : (pagedResult?.items || []);
  const totalCount = isFiltering ? filteredData.length : (pagedResult?.totalCount ?? 0);
  const pageCount = isFiltering
    ? Math.max(1, Math.ceil(filteredData.length / itemsPerPage))
    : (pagedResult?.pageCount ?? 1);
  const isLoading = isFiltering ? isLoadingAll : isLoadingPage;
  const itemOffset = (pageNumber - 1) * itemsPerPage;
  const endOffset = Math.min(itemOffset + itemsPerPage, totalCount);

  const handlePageClick = (event: any) => {
    set_pageNumber(event.selected + 1);
  };

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <Box>
          <TopDisplay
            label="Migrate Student To Membership"
            button_array={[
              <Button
                bg="var(--dark-green-color)"
                color="var(--white-color)"
                leftIcon={<ApprovalIcon />}
                variant="outline"
                colorScheme="var(--dark-green-color)"
                onClick={showBatchAproval}
              >
                Batch Migration
              </Button>,
              // <UploadButton label="Upload Candidates" />
            ]}
          />
          <Flex gap="20px" wrap="wrap" mt="20px">
            <InputGroup
              h="40px"
              width="250px"
              bg="var(--white-color)"
              borderColor="var(--dark-green-color)"
              pos="relative"
            >
              <InputLeftElement pointerEvents="none">
                <SearchIcon color="gray.300" />
              </InputLeftElement>
              <Input
                value={search}
                onChange={(e: any) => set_search(e.target.value)}
                type="text"
                placeholder="search"
              />
              <span
                style={{
                  position: "absolute",
                  zIndex: "1",
                  right: "10px",
                  cursor: "pointer",
                  top: "12px",
                }}
                onClick={() => set_search("")}
              >
                <ReloadIcon />
              </span>
            </InputGroup>
            <Select
              placeholder="Status"
              width="130px"
              bg="var(--white-color)"
              borderColor="var(dark-green-color)"
              onChange={(e: any) => set_selected_status(e.target.value)}
            >
              <option>Applied For Induction</option>
              <option>Inducted</option>
            </Select>
          </Flex>
          <Flex mt="25px" flexDir="column" gap="10px">
            <Heading m="0" fontSize="1rem">
              All Applied For Induction Student
            </Heading>
            <Text m="0" fontSize=".8rem">
              Showing {totalCount === 0 ? 0 : itemOffset + 1} - {endOffset} of {totalCount}
            </Text>
          </Flex>
          {currentItems && currentItems.length > 0 ? (
            <TableContainer mt="20px">
              <Table size="sm">
                <Thead>
                  <Tr>
                    <Th sx={HeadStyle}>S/N</Th>
                    <Th sx={HeadStyle}>Student No</Th>
                    <Th sx={HeadStyle}>First Name</Th>
                    <Th sx={HeadStyle}>Last Name</Th>
                    <Th sx={HeadStyle}>IsMoved</Th>
                    <Th sx={HeadStyle}>FinalMemberNo</Th>
                    <Th sx={HeadStyle}>IsOld</Th>
                    <Th sx={HeadStyle}>Status</Th>
                    <Th sx={HeadStyle} w="50px"></Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {currentItems.map((eCandidate: any, index: number) => (
                    <ROWSTYLE key={eCandidate.Id}>
                      <Td sx={DataStyle}>{eCandidate.SN}</Td>
                      <Td sx={DataStyle}>{eCandidate.StudentNo}</Td>
                      <Td sx={DataStyle}>{eCandidate.FirstName}</Td>
                      <Td sx={DataStyle}>{eCandidate.LastName}</Td>
                      <Td sx={DataStyle}>
                        {eCandidate.IsMovedToMembership ? "Yes" : "No"}
                      </Td>
                      <Td sx={DataStyle}>
                        {eCandidate.FinalMembershipNo || "N/A"}
                      </Td>
                      <Td sx={DataStyle}>
                        {eCandidate.IsOldStudent ? "Yes" : "No"}
                      </Td>
                      <Td sx={DataStyle}>{eCandidate.Status}</Td>
                      <Td sx={DataStyle} minW="60px" w="50px" h="50px">
                        <div className={activeIndex === index ? "active" : ""}>
                          <Option {...{ index, candidate: eCandidate }} />
                        </div>
                      </Td>
                    </ROWSTYLE>
                  ))}
                </Tbody>
              </Table>
            </TableContainer>
          ) : (
            "No Students"
          )}
          <StylePaginateBox>
            <ReactPaginate
              breakLabel="..."
              nextLabel=">"
              onPageChange={handlePageClick}
              pageRangeDisplayed={5}
              pageCount={pageCount}
              previousLabel="<"
              renderOnZeroPageCount={null}
            />
          </StylePaginateBox>
        </Box>
      )}
    </>
  );
}

const StylePaginateBox = styled.div`
  width: 100%;
  & > ul {
    list-style-type: none;
    text-align: center;
    padding: 0;
    margin: 0;
    margin-top: 10px;
  }
  & > ul > li {
    display: inline;
    margin: 0 5px;
    padding: 2px 5px;
    border-radius: 3px;
    background-color: transparent;
    color: var(--dark-green-color);
  }
  & > ul > li.selected {
    background-color: var(--highlight-paginate-background);
    color: var(--highlight-paginate-color);
  }
  & > ul > li:first-of-type,
  & > ul > li:last-of-type {
    font-weight: bold;
  }
`;

const sx = {
  ":hover": {
    bg: "var(--content-background)",
  },
};

const Option = (props: any) => {
  const index = props.index;
  const candidate = props.candidate;
  const [ind, set_index] = useAtom(indexAtom);
  const [, set_open] = useAtom(openAtom);
  const [, set_modal] = useAtom(modalAtom);
  const onClick = () => {
    if (index === ind) {
      set_index(null);
      return;
    }
    set_index(index);
  };
  const handleShowProfile = () => {
    set_index(null);
    set_modal({
      header: "Student Details",
      content: <ViewProfile candidate={candidate} />,
    });
    set_open(true);
  };

  const handleSingleMigrate = () => {
    set_index(null);
    set_modal({
      header: "Migrate to Membership",
      content: <ViewSingleMigrate {...candidate} />,
    });
    set_open(true);
  };
  useEffect(() => {
    return () => set_index(null);
  }, []);
  return (
    <Popover>
      <PopoverTrigger>
        <Button onClick={onClick} bg="var(--cipm-light-green)">
          <MoreIcon />
        </Button>
      </PopoverTrigger>
      <PopoverContent width="fit-content">
        <PopoverArrow />
        <PopoverBody>
          <Grid templateColumns="1fr" p="6px">
            <GridItem sx={sx} p="8px 4px" onClick={handleShowProfile}>
              View Details
            </GridItem>
            {/* <GridItem sx={sx} p="8px 4px">View Details</GridItem> */}
            <GridItem sx={sx} p="8px 4px" onClick={handleSingleMigrate}>
              Migrate Student
            </GridItem>
          </Grid>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
};

const ViewProfile = (props: any) => {
  return (
    <Flex flexDir="column" minWidth="600px" gap="50px">
      <Flex align="center" gap="20px">
        {/* <Image
          src="/public-assets/profile.png"
          width="150px"
          height="150px"
          objectFit="contain"
          objectPosition="center"
          alt="profile"
        /> */}
        <Flex gap="20px">
          {/* <Heading fontSize="1rem">{props.candidate.FirstName+" "+props.candidate.LastName}</Heading> */}
          <Text width="150px" fontWeight="500" color="var(--light-text)">
            Student NO
          </Text>
          <Text> {props.candidate.StudentNo}</Text>
        </Flex>
      </Flex>
      <Grid templateColumns="1fr" templateRows="repeat(3,1fr)" gap="30px">
        <GridItem as={Flex} gap="20px">
          <Text width="150px" fontWeight="500" color="var(--light-text)">
            First Name
          </Text>
          <Text fontWeight="500">
            {props.candidate.FirstName || "Osakpolo@gmail.com"}
          </Text>
        </GridItem>
        <GridItem as={Flex} gap="20px">
          <Text width="150px" fontWeight="500" color="var(--light-text)">
            LastName
          </Text>
          <Text fontWeight="500">
            {props.candidate.LastName || "Not working"}
          </Text>
        </GridItem>
        <GridItem as={Flex} gap="20px">
          <Text width="150px" fontWeight="500" color="var(--light-text)">
            Status
          </Text>
          <Text fontWeight="500">{props.candidate.Status || "Pending"}</Text>
        </GridItem>
      </Grid>
    </Flex>
  );
};
const ViewSingleMigrate = (props: any) => {
  const [, set_open] = useAtom(openAtom);
  const [, set_n_open] = useAtom(openNAtom);
  const [, set_notification] = useAtom(notificationAtom);
  const queryClient = useQueryClient();
  const [Reason, set_reason] = useState(props?.Reason || "");

  const { isLoading: moveIsLoading, mutate: update_move_membership } =
    useMutation({
      mutationKey: ["move-to-membership"],
      mutationFn: async (studentNumbers: string) =>
        await apiCall().post(
          `/Exam/BatchMoveToMembership?studentNumbers=${studentNumbers}`,
          {}
        ),
      onSuccess(data: any) {
        //console.log(data,'data')
        set_notification({
          type: "success",
          message:
            data.data.Message || "Student Moved To Membership Successfully",
        });
        set_n_open(true);
        queryClient.invalidateQueries(["applied-induction-page"]);
        queryClient.invalidateQueries(["applied-induction-all"]);
      },
      onError(error: any) {
        set_notification({
          type: "error",
          message: error.data.Message || "Error Occured",
        });
        set_n_open(true);
      },
      onSettled() {
        set_open(false);
      },
    });

  return (
    <Flex flexDir="column" minWidth="600px" gap="50px">
      <Flex gap="10px" flexDir="column">
        <Flex gap="20px">
          <span>Student No:</span>
          <Text m="0" fontWeight="600">
            {props?.StudentNo}
          </Text>
        </Flex>
        <Flex gap="20px">
          <span>First Name:</span>
          <Text m="0" fontWeight="600">
            {props?.FirstName}
          </Text>
        </Flex>
        <Flex gap="40px">
          <span>Last Name:</span>
          <Text m="0" fontWeight="600">
            {props?.LastName}
          </Text>
        </Flex>
        <Flex gap="43px">
          <span>Status:</span>
          <Text m="0" fontWeight="600">
            {props?.Status}
          </Text>
        </Flex>
      </Flex>
      {/* <label>
          <Box fontWeight="500">Comment</Box>
          <Textarea placeholder="comment" resize="vertical" size="sm" value={Reason} 
          onChange={(e:any)=>set_reason(e.target.value)} 
          />
        </label> */}
      <Flex justify="center" gap="30px" align="center">
        <Button
          onClick={() => update_move_membership(props.StudentNo)}
          bg="var(--dark-green-color)"
          color="var(--white-color)"
          width="130px"
          disabled={moveIsLoading}
        >
          {moveIsLoading ? "Loading" : "Move"}
        </Button>
      </Flex>
    </Flex>
  );
};
